import { render, staticRenderFns } from "./kpi-board.vue?vue&type=template&id=6f43d789&scoped=true"
import script from "./kpi-board.vue?vue&type=script&lang=ts"
export * from "./kpi-board.vue?vue&type=script&lang=ts"
import style0 from "./kpi-board.vue?vue&type=style&index=0&id=6f43d789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f43d789",
  null
  
)

export default component.exports